import { InternalAxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import cookie from 'js-cookie';
import { makeApiClient } from '~/api/client';
import authApi from '~/authApi';
import { PDF_DOCUMENT_TYPE } from '~/constants';

import { SHARED_TOKEN_PREFIX, SHARED_TOKEN_SUFIX } from './pdfApi.constants';

const BASE_URL = process.env.NEXT_PUBLIC_PDF_RESOURCE ?? '';

const requestInterceptor = (req: InternalAxiosRequestConfig) => {
  const accessToken = cookie.get('accessToken');
  if (accessToken && !req.headers.Authorization) {
    req.headers['Authorization'] = `Bearer ${accessToken}`;
  } else {
    req.headers['Authorization'] =
      `Bearer ${SHARED_TOKEN_PREFIX}${SHARED_TOKEN_SUFIX}`;
  }
  return req;
};

const client = makeApiClient(
  BASE_URL,
  {
    headers: {
      'Allow-Origin': '*',
      'Content-Type': 'application/octet-stream',
    },
  },
  requestInterceptor,
);

createAuthRefreshInterceptor(client, (failedRequest) => {
  return authApi.refreshAccessToken().then((newToken) => {
    failedRequest.response.config.headers['Authorization'] =
      `Bearer ${newToken?.accessToken}`;
    return Promise.resolve();
  });
});

const create = (params: { pdfType: PDF_DOCUMENT_TYPE; data: any }) => {
  return client.post('/api/pdf', params, {
    responseType: 'blob',
  });
};

export const pdfApi = { create };
